import React from 'react';
import type {
  PointChargeTop_PointChargeProductFragment,
  PointChargeTop_PointChargeProductsQuery,
} from '@/gql/__codegen__/graphql';
import { usePointChargeProductsQuery } from './hooks/usePointChargeProductsQuery';

type State = {
  pageStatus: 'INIT' | 'CONFIRM';
  products: PointChargeTop_PointChargeProductFragment[];
};

type Action = {
  type: 'INITIALIZED';
  payload: {
    data: PointChargeTop_PointChargeProductsQuery;
  };
};

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case 'INITIALIZED': {
      const {
        pointChargeProducts: { products },
      } = action.payload.data;

      return {
        ...state,
        pageStatus: 'CONFIRM',
        products,
      };
    }
  }
};

export type UsePointChargeTop = {
  state: State;
};

export function usePointChargeTop(): UsePointChargeTop {
  const [state, dispatch] = React.useReducer(reducer, {
    pageStatus: 'INIT',
    products: [],
  });

  usePointChargeProductsQuery({
    onCompleted(data) {
      dispatch({
        type: 'INITIALIZED',
        payload: {
          data,
        },
      });
    },
  });

  return {
    state,
  };
}
